import GreenAudioPlayer from "./green-audio-player"
const initAudio = () => {
  GreenAudioPlayer.init({
    selector: '.audioplayer', // inits Green Audio Player on each audio container that has class "player"
    stopOthersOnPlay: true
  });
}

export { initAudio }
